// extracted by mini-css-extract-plugin
var _1 = "n7_DcyVfnVhTplui9ECo";
var _2 = "170px";
var _3 = "2px";
var _4 = "aTjoUMRu2oXLVIg7ATCa";
var _5 = "WOaOyxff3ZvZRuDOqOql";
export { _1 as "extended", _2 as "imageheight", _3 as "imagepadding", _4 as "images", _5 as "item" }
